import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useIsAuthenticated } from '@azure/msal-react';
import PropTypes from 'prop-types';

function ProtectedRoute({ children }) {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  if (!isAuthenticated) {
    // return <Navigate to="/" replace />;

    // reference https://www.robinwieruch.de/react-router-authentication/
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.object.isRequired
};

export default ProtectedRoute;
